/* istanbul ignore file */
import React from "react"

const btnStyle = {width: "50%"}

const style: React.CSSProperties = {
    border: "3px solid white",
    right: 0,
    margin: 0,
    padding: 0,
}

interface FavsType {
    ShoppingListItems: {test: string}[]
}
const noFavs = {ShoppingListItems: []}
const FavsSingle = {ShoppingListItems: [{test: "test"}]}
const FavsMultiple = {ShoppingListItems: [{test: "test"}, {test: "test2"}]}

const Auth = () => {
    const handleFavs = (hasFavs: boolean, Favs?: FavsType) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        ;(window as any).subjects["$ FAVOURITES_GET_CALLBACK"].next({
            success: true,
            data: hasFavs ? Favs : noFavs,
            status: 200,
            textStatus: "test",
            eventId: "test",
        })
    }

    return (
        <div style={style}>
            <button type="button" style={btnStyle} onClick={() => handleFavs(true, FavsMultiple)}>
                2+ Favourites
            </button>
            <button type="button" style={btnStyle} onClick={() => handleFavs(true, FavsSingle)}>
                1+ Favourites
            </button>
            <button type="button" style={btnStyle} onClick={() => handleFavs(false)}>
                0 Favourites
            </button>
        </div>
    )
}

export default Auth
